import "../css/Loading.css"

function SectionTwo() {
  return (
    <div className="dashboard-l">
      <div className="main-content-l">
        <div className="info-section-l1">
        </div>
        <div className="info-section-l2" />
        <div className="info-section-l3" />
        <div className="info-section-l4" />
      </div>
    </div>
  );
}

export default SectionTwo;